import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { faChevronDown, faChevronUp, faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { Question } from '@empathy/survey-core';

import { QuestionTypeConfig } from '../../../models/question-type-config.constants';

@Component({
  selector: 'empathy-question-library-item',
  templateUrl: 'question-library-item.component.html',
  styleUrls: ['./question-library-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionLibraryItemComponent {
  isChecked = input<boolean>();
  question = input<Question>();

  checked = output<MatCheckboxChange>();
  deleteQuestion = output<string>();

  hasContent$ = computed(() => this.question().options?.length > 0 || this.question().cards?.length > 0 || !!this.question().ratingType);
  cardsFiltered$ = computed(() => (this.expandedCards$() && this.hasContent$() ? this.question().cards : this.question().cards.slice(0, 3)));
  optionsFiltered$ = computed(() => (this.expandedOptions$() && this.hasContent$() ? this.question().options : this.question().options.slice(0, 3)));

  expandedCards$ = signal(false);
  expandedOptions$ = signal(false);

  faEllipsisVertical = faEllipsisVertical;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;

  questionTypeConfig = QuestionTypeConfig;
}
